import { animate, stagger, inView } from 'motion';

const animationSections = document.querySelectorAll('[data-animate-words');
const highlightedWords = document.querySelectorAll('.highlight');

highlightedWords.forEach((word) => {
  const spanEl = document.createElement('span');
  word.append(spanEl);
});

setTimeout(() => {
  inView(
    animationSections,
    ({ target }) => {
      const words = target.querySelectorAll('.highlight span');

      if (words.length) {

        animate(words, { width: ['0%', '100%'], opacity: [0, 1] }, { delay: stagger(0.25), duration: 0.3, easing: 'ease-in' },);
      }
    },
    {
      margin: '0% 0% -35% 0%',
    },
  );
}, 500);
